export default [
  {
    path: '/api/production/plan',
    name: 'ProductionPlanList',
    meta: {
      pageTitle: '생산관리',
      title: '생산계획',
      authRequired: true,
    },
    component: () => import('@/views/production/productionPlan')
  },
  {
    path: '/api/production/actual',
    name: 'ProductionActualList',
    meta: {
      pageTitle: '생산관리',
      title: '생산실적',
      authRequired: true,
    },
    component: () => import('@/views/production/productionActual')
  },

]
